import type { PainPoint } from '../types/product';

export const painPoints: PainPoint[] = [
  {
    title: 'Arrivo senza un percorso chiaro',
    consequence: 'Improvviso l’ordine dell’incontro e faccio fatica a individuare una priorità.',
  },
  {
    title: 'Esito nella scelta dei fiori',
    consequence: 'Ricordo le parole chiave, ma non sempre so come distinguere descrizioni simili.',
  },
  {
    title: 'Manca una chiusura definita',
    consequence: 'La persona non sa bene che cosa osservare o quale sarà il passo successivo.',
  },
  {
    title: 'Non ho continuità nel follow-up',
    consequence: 'Ogni incontro richiede di ricostruire il percorso da capo.',
  },
  {
    title: 'La disponibilità occupa tutto il mio tempo',
    consequence: 'Messaggi e richieste arrivano senza accordi chiari.',
  },
  {
    title: 'Faccio fatica a comunicare il valore',
    consequence: 'Non riesco a spiegare con semplicità che cosa comprende il mio servizio.',
  },
];
